(() => {
  'use strict';
  const root = document.getElementById('mayhem-support');
  if (!root || root.dataset.answersReady) return;
  root.dataset.answersReady = 'true';
  const engine = window.MayhemSupportAnswers;
  const labels = JSON.parse(document.querySelector('[data-mhs-answer-labels]').textContent);
  const q = selector => root.querySelector(selector);
  // Keep app-owned custom elements and verification frames alive when possible.
  const placeContactNode=(parent,node,before=null)=>{
    if(node.parentNode===parent && node.nextSibling===before)return;
    if(typeof parent.moveBefore==='function' && parent.isConnected && node.isConnected){
      try{parent.moveBefore(node,before);return;}catch{}
    }
    parent.insertBefore(node,before);
  };
  const dialog = q('dialog'), panel = q('[data-mhs-answer-panel]'), home = q('[data-mhs-home]');
  const wheel = q('[data-mhs-wheel]'), variant = q('[data-mhs-variant]');
  const input = q('#MayhemSupportQuestion'), result = q('[data-mhs-answer-result]'), status = q('[data-mhs-answer-status]');
  let rows = [], pending, generation = 0, returning = false;
  const route = path => {
    const url = new URL((root.dataset.root || '/') + path, location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  };
  const vehicle = () => {
    const native=window.TWGFitmentPreview?.selectedVehicle();
    if(native)return {id:'fg:'+JSON.stringify(native.query),native:true,label:native.label,year:native.label.split(' · ')[0],model:native.label.split(' · ')[2]};
    return null;
  };
  const vehicleDescription = selected => selected?.native ? selected.label : selected ? [...new Set(['year','make','model','submodel','body','bed'].flatMap(key => String(selected[key] || '').split(' · ')).map(value => value.trim()).filter(Boolean))].join(' ') : '';
  const refreshSummary = () => {
    const selected=vehicle();
    const vehicleText=vehicleDescription(selected);
    const row=rows.find(r=>String(r.variantId)===variant.value)||rows.find(r=>String(r.productId)===wheel.value);
    const wheelText=row?[row.title,variant.value?row.sku:''].filter(Boolean).join(' · '):'';
    const indicator=q('[data-mhs-selected-wheel]');
    indicator.hidden=!row;
    q('[data-mhs-selected-wheel-label]').textContent=row?'Asking about: '+[row.title,variant.value?row.size:'All configurations',variant.value?row.sku:''].filter(Boolean).join(' · '):'';
    q('[data-mhs-context-summary]').textContent=[vehicleText,wheelText].filter(Boolean).join(' / ')||'Add details if you have them';
    drawFollowups();
  };
  const refreshVehicle = () => {
    const selected = vehicle();
    q('[data-mhs-selected-vehicle]').textContent = selected ? labels.vehicle_label + vehicleDescription(selected) : labels.vehicle_none;
    q('[data-mhs-pick-vehicle]').textContent = selected ? 'Change vehicle' : 'Select vehicle';
    q('[data-mhs-clear-vehicle]').hidden = !selected;
    refreshSummary();
  };
  // Use the same vehicle IDs, storage keys and event as the site header.
  const vehiclePicker=q('[data-mhs-vehicle-picker]');
  const vehicleFields=['year','make','model','trim','body'].map(name=>q(`[data-mhs-vehicle-field="${name}"]`));
  const vehicleMessage=q('[data-mhs-vehicle-message]'), vehicleApply=q('[data-mhs-vehicle-apply]');
  let vehicleRows=[], vehicleRequest=0, vehicleStage=0, vehicleController, nativePicker;
  const nativeHost=document.createElement('div');nativeHost.hidden=true;vehiclePicker.after(nativeHost);
  const vehicleOptions=(field,options,label)=>{
    field.replaceChildren(new Option(label,''));
    options.forEach(option=>field.add(new Option(option.label,option.value)));
    field.disabled=!options.length;
  };
  const resetVehicleFields=start=>{
    vehicleFields.slice(start).forEach((field,index)=>vehicleOptions(field,[],['Select year','Select make','Select model','Select trim','Select body / bed'][start+index]));
    vehicleApply.disabled=true;
  };
  const closeVehiclePicker=()=>{
    nativePicker?.destroy();nativePicker=null;nativeHost.hidden=true;
    if(!vehiclePicker.hidden)window.dispatchEvent(new CustomEvent('mayhem:picker-closed',{detail:{surface:'support'}}));
    ++vehicleRequest; vehicleController?.abort(); vehiclePicker.hidden=true;
    q('[data-mhs-pick-vehicle]').setAttribute('aria-expanded','false');
    q('[data-mhs-pick-vehicle]').focus();
  };
  const loadVehicleChoices=async stage=>{
    vehicleMessage.textContent='Vehicle lookup is unavailable. Please refresh and try again.';return;
    vehicleController?.abort(); const controller=new AbortController(); vehicleController=controller;
    const token=++vehicleRequest; vehicleStage=stage;
    vehicleMessage.textContent='Loading vehicle choices…';
    q('[data-mhs-vehicle-retry]').hidden=true;
    resetVehicleFields(stage);
    if(stage===4){
      const rows=vehicleRows.filter(row=>(row.Submodel||'Base')===vehicleFields[3].value);
      const labels=rows.map(row=>[row.Body||'Body unspecified',row.Bed].filter(Boolean).join(' · '));
      vehicleOptions(vehicleFields[4],rows.map((row,i)=>({value:String(row.Id),label:labels[i]+(labels.indexOf(labels[i])!==labels.lastIndexOf(labels[i])?' · ID '+row.Id:'')})),'Select body / bed');
      if(rows.length===1){vehicleFields[4].value=String(rows[0].Id);vehicleApply.disabled=false;}
      vehicleMessage.textContent=rows.length?'':'No vehicles found.'; return;
    }
    let timedOut=false;
    const timer=setTimeout(()=>{timedOut=true;controller.abort();},20000);
    const paths=['/vehicles/years','/vehicles/makes','/vehicles/models','/vehicles'];
    const collections=['Years','Makes','Models','Vehicles'];
    try{
      const rows=[];
      for(let page=1;page<=50;page++){
        const url=new URL('https://api.autosyncstudio.com'+paths[stage]);
        url.searchParams.set('key','mayhem');url.searchParams.set('p-size','500');url.searchParams.set('p-number',String(page));
        ['year','make','model'].slice(0,stage).forEach((name,index)=>url.searchParams.set('f-'+name,vehicleFields[index].value));
        if(stage===3){url.searchParams.set('i-img001','true');url.searchParams.set('i-fitments','1');}
        const response=await fetch(url,{signal:controller.signal});
        if(!response.ok)throw new Error('Vehicle choices unavailable');
        const data=await response.json();
        if(data.Error||!Array.isArray(data[collections[stage]]))throw new Error('Vehicle choices unavailable');
        rows.push(...data[collections[stage]].map(row=>{
          if(stage!==3)return row;
          const image=row.Img001?.['350']||row.Img001?.['240'];
          return {...row,photoUrl:image&&data.ImgUrlBase?new URL(image,data.ImgUrlBase).href:null};
        }));
        if(!data.MoreItems)break;
        if(page===50)throw new Error('Incomplete vehicle choices');
      }
      if(token!==vehicleRequest||vehiclePicker.hidden)return;
      let values;
      if(stage===3){
        vehicleRows=[...new Map(rows.filter(row=>Number.isSafeInteger(Number(row.Id))&&Number(row.Id)>0).map(row=>[String(row.Id),row])).values()];
        values=vehicleRows.map(row=>row.Submodel||'Base');
      }else values=rows.map(row=>String(typeof row==='object'?row[['Year','Make','Model'][stage]]??row.Name??row.Value??'':row)).filter(Boolean);
      values=[...new Set(values)].sort(stage===0?(a,b)=>Number(b)-Number(a):(a,b)=>a.localeCompare(b));
      vehicleOptions(vehicleFields[stage],values.map(value=>({value,label:value})),['Select year','Select make','Select model','Select trim'][stage]);
      vehicleMessage.textContent=values.length?'':'No vehicles found for this selection.';
    }catch(error){
      if((error.name==='AbortError'&&!timedOut)||token!==vehicleRequest||vehiclePicker.hidden)return;
      vehicleMessage.textContent='Vehicle choices are unavailable. Please try again.';
      q('[data-mhs-vehicle-retry]').hidden=false;
    }finally{clearTimeout(timer);}
  };
  const openVehiclePicker=()=>{
    if(window.TWGFitmentPreview?.status().enabled && window.TWGFitmentPreview.status().mode==='twg_app_draft'){
      closeVehiclePicker();nativeHost.hidden=false;
      nativePicker=window.TWGFitmentPreview.mountVehicleSelector(nativeHost,{showResults:false});
      q('[data-mhs-pick-vehicle]').setAttribute('aria-expanded','true');return;
    }
    vehiclePicker.hidden=false;window.dispatchEvent(new CustomEvent('mayhem:picker-opened',{detail:{surface:'support'}}));q('[data-mhs-pick-vehicle]').setAttribute('aria-expanded','true');
    resetVehicleFields(0);loadVehicleChoices(0);vehiclePicker.scrollIntoView({block:'nearest'});
  };
  dialog.addEventListener('close',()=>{if(!vehiclePicker.hidden||nativePicker)closeVehiclePicker();});
  vehicleFields.forEach((field,index)=>field.addEventListener('change',()=>{
    ++vehicleRequest;vehicleController?.abort();resetVehicleFields(index+1);
    if(index===4){vehicleApply.disabled=!vehicleRows.some(row=>String(row.Id)===field.value);return;}
    if(field.value)loadVehicleChoices(index+1);
  }));
  vehiclePicker.addEventListener('submit',event=>{
    event.preventDefault();if(vehicleApply.disabled)return;
    const row=vehicleRows.find(row=>String(row.Id)===vehicleFields[4].value&&(row.Submodel||'Base')===vehicleFields[3].value);
    if(!row)return;
    const selected={id:String(row.Id),year:String(row.Year),make:row.Make,model:row.Model,submodel:row.Submodel||'Base',body:row.Body,bed:row.Bed,photoUrl:row.photoUrl};
    for(const storage of [window.localStorage,window.sessionStorage]){
      try{storage.setItem('mayhem:selected-vehicle-id',selected.id);storage.setItem('mayhem:selected-vehicle',JSON.stringify(selected));}catch{}
    }
    window.dispatchEvent(new CustomEvent('mayhem:picker-completed',{detail:{surface:'support'}}));
    closeVehiclePicker();
    window.dispatchEvent(new CustomEvent('mayhem:vehicle-changed',{detail:{id:selected.id,vehicle:selected,source:'support'}}));
  });
  const variants = () => {
    variant.replaceChildren(new Option(labels.all_configurations, ''));
    rows.filter(row => String(row.productId) === wheel.value).forEach(row => variant.add(new Option([row.sku, row.size, row.boltOption, row.offset == null ? '' : row.offset + ' mm'].filter(Boolean).join(' · '), String(row.variantId))));
  };
  const load = () => {
    if (pending) return pending;
    pending = (async () => {
      status.textContent = labels.loading;
      let next = route('collections/all-wheels'), page = 0;
      const loaded = [], visited = new Set();
      while (next) {
        const url = new URL(next, location.origin);
        if (url.origin !== location.origin || visited.has(url.href) || page >= 50) throw new Error('Invalid catalog pagination');
        url.searchParams.set('section_id', 'mayhem-support-data');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        visited.add(url.href);
        const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 15000);
        let data;
        try {
          const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
          if (!response.ok) throw new Error('Catalog unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          data = JSON.parse(doc.querySelector('[data-mhs-catalog]').textContent);
        } finally { clearTimeout(timer); }
        if (!Array.isArray(data.rows) || data.page !== page + 1) throw new Error('Incomplete catalog');
        loaded.push(...data.rows); page++;
        if (!data.next && page !== data.pages) throw new Error('Incomplete catalog');
        next = data.next;
      }
      rows = [...new Map(loaded.map(row => [String(row.variantId), row])).values()];
      if (!rows.length) throw new Error('Empty catalog');
      wheel.replaceChildren(new Option(labels.choose_wheel, ''));
      [...new Map(rows.map(row => [String(row.productId), row])).values()].forEach(row => wheel.add(new Option(row.title, String(row.productId))));
      if (rows.some(row => String(row.productId) === root.dataset.productId)) wheel.value = root.dataset.productId;
      variants(); const currentVariant=new URL(location.href).searchParams.get('variant'); if(rows.some(row=>String(row.variantId)===currentVariant&&String(row.productId)===wheel.value))variant.value=currentVariant; restoreState(); refreshSummary(); status.textContent = '';
    })().catch(error => { pending = null; status.textContent = labels.load_error; throw error; });
    return pending;
  };
  const element = (tag, text, parent = result) => { const node = document.createElement(tag); node.textContent = text; parent.append(node); return node; };
  const link = (text, url, parent = result) => {
    const safe = new URL(url, location.origin);
    if (safe.origin !== location.origin) return;
    const node = element('a', text, parent); node.href = safe.href; return node;
  };
  const fitLabel = state => ({fits:labels.fits,caution:labels.caution,nofit:labels.nofit,unknown:labels.unavailable}[state] || labels.unavailable);
  const fitmentRecovery = (fit,row,parent) => {
    if(!['nofit','unknown'].includes(fit.state))return;
    const actions=element('div','',parent);actions.className='mhs-config-actions';
    if(fit.state==='nofit'){
      const alternatives=element('button',labels.alternatives,actions);alternatives.type='button';
      alternatives.addEventListener('click',()=>{browseFitment=true;result.replaceChildren();panel.querySelector('h3').textContent=labels.vehicle_wheels;q('.mhs-chat-intro').textContent=labels.options_intro;discoverFitment();optionsBox.scrollIntoView({block:'start'});});
    }
    const contact=link(labels.ask_team,route('pages/contact'),actions);
    if(contact)contact.dataset.mhsContactVariant=String(row.variantId);
  };
  const card = row => {
    const article = element('article', '');
    element('h4', row.title, article);
    element('p', [row.sku, row.size, row.boltOption, row.offset == null ? '' : row.offset + ' mm'].filter(Boolean).join(' · '), article);
    const url = new URL(row.url, location.origin); url.searchParams.set('variant', row.variantId);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    link(labels.view_wheel, url, article);
    return article;
  };

  let browseFitment=false, fitmentRequest=0;
  let fitmentFilters={size:'',finish:''};
  const optionsBox=q('[data-mhs-fitment-options]');
  const discoverFitment=async()=>{
    const requestId=++fitmentRequest, selected=vehicle();
    optionsBox.replaceChildren();
    if(!selected){
      element('p','Select your vehicle to see wheel options.',optionsBox);
      return;
    }
    const progress=element('p','Checking wheel configurations…',optionsBox);progress.setAttribute('role','status');
    const current=()=>requestId===fitmentRequest&&String(vehicle()?.id)===String(selected.id)&&browseFitment;
    try{
      await load();if(!current())return;
      const service=window.MayhemFitmentService;
      const nativeFits=selected.native?await Promise.all(rows.map(row=>window.TWGFitmentPreview.evaluateSku(row.sku))):null;
      const [vehicleData,wheelData]=selected.native?[null,new Map()]:await Promise.all([service.vehicle(selected.id),service.wheels(rows.map(row=>row.sku)).catch(() => new Map())]);
      if(!current())return;
      const groups=new Map();let unknown=0;
      for(const [index,row] of rows.entries()){
        const fit=nativeFits?nativeFits[index]:service.evaluate(vehicleData,window.MayhemManufacturerFitment.wheel(row,wheelData.get(String(row.sku).toUpperCase())));
        if(fit.state==='unknown')unknown++;
        if(!['fits','caution'].includes(fit.state))continue;
        const key=String(row.productId);
        if(!groups.has(key))groups.set(key,[]);
        groups.get(key).push({row,fit});
      }
      const options=[...groups.values()].sort((a,b)=>{
        const rank=items=>items.some(item=>item.fit.state==='fits')?0:1;
        return rank(a)-rank(b)||a[0].row.title.localeCompare(b[0].row.title);
      });
      progress.textContent=options.length?options.length+' wheel / finish options. Choose a configuration to view it.':labels.no_options;
      if(unknown)window.MayhemJourney?.track('fitment_unavailable',{surface:'support',state:'unknown'});
      if(unknown){element('p',labels.some_unverified,optionsBox).className='mhs-note';link(labels.ask_team,route('pages/contact'),optionsBox);}
      if(!options.length){if(!unknown)link(labels.ask_team,route('pages/contact'),optionsBox);return;}
      const filters=element('div','',optionsBox);filters.className='mhs-result-filters';
      const makeFilter=(name,title,values)=>{
        const label=element('label',title,filters);
        const select=element('select','',label);select.setAttribute('aria-label',title);
        select.add(new Option('All '+title.toLowerCase(),''));
        values.forEach(value=>select.add(new Option(value,value)));
        select.value=values.includes(fitmentFilters[name])?fitmentFilters[name]:'';
        fitmentFilters[name]=select.value;
        select.addEventListener('change',()=>{fitmentFilters[name]=select.value;paintFiltered();saveState();});
        return select;
      };
      const matches=options.flat();
      const sizes=makeFilter('size','Sizes',[...new Set(matches.map(x=>x.row.size).filter(Boolean))].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true})));
      const finishes=makeFilter('finish','Finishes',[...new Set(matches.map(x=>x.row.finish).filter(Boolean))].sort());
      const clear=element('button','Reset filters',filters);clear.type='button';
      clear.addEventListener('click',()=>{sizes.value='';finishes.value='';fitmentFilters={size:'',finish:''};paintFiltered();saveState();});
      const listBox=element('div','',optionsBox);
      let shown=0,filtered=options;
      const renderMore=()=>{
        for(const items of filtered.slice(shown,shown+8)){
          items.sort((a,b)=>(a.fit.state==='fits'?0:1)-(b.fit.state==='fits'?0:1)||Number(a.row.diameter)-Number(b.row.diameter)||Number(a.row.width)-Number(b.row.width));
          const row=items[0].row,article=element('article','',listBox);article.className='mhs-fitment-option';
          if(row.image){
            const url=new URL(row.image,location.origin);
            if(url.protocol==='https:'){const img=document.createElement('img');img.src=url.href;img.alt=row.title;img.loading='lazy';img.width=96;img.height=96;article.append(img);}
          }
          element('h4',row.title,article);
          if(row.finish)element('p',row.finish,article).className='mhs-note';
          let moreConfigurations;
          for(const [index,item] of items.entries()){
            if(index===1){moreConfigurations=element('details','',article);moreConfigurations.className='mhs-more-configurations';element('summary',labels.more_configurations.replace('[count]',String(items.length-1)),moreConfigurations);}
            const config=element('div','',index?moreConfigurations:article);config.className='mhs-fitment-config';
            element('strong',item.fit.label||fitLabel(item.fit.state),config);
            const url=new URL(item.row.url,location.origin);url.searchParams.set('variant',item.row.variantId);
            const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
            element('p',[item.row.size,item.row.boltOption,item.row.offset==null?'':item.row.offset+' mm',item.row.sku].filter(Boolean).join(' · '),config).className='mhs-config-specs';
            const productLink=element('a','View wheel details →',config);productLink.href=url.href;productLink.className='mhs-wheel-details';
            productLink.setAttribute('aria-label','View '+item.row.title+' '+item.row.sku+' details');
            const actions=element('div','',config);actions.className='mhs-config-actions';
            if(selected.native && window.TWGFitmentPreview?.selectedVehicle()?.query.provider==='twg_app'){const previewButton=element('button','View on vehicle',actions);previewButton.type='button';previewButton.dataset.twgVisualizerSku=item.row.sku;previewButton.className='mhs-view-on-vehicle';}
            const ask=element('button','Ask about this wheel',actions);ask.type='button';ask.className='mhs-ask-wheel';
            ask.setAttribute('aria-label','Ask about '+item.row.title+' '+item.row.size+' '+item.row.sku);
            ask.addEventListener('click',()=>chooseWheel(item.row));
            const spec=wheelData.get(String(item.row.sku).toUpperCase());
            const hasImage=value=>typeof value==='string'?value.length>0:value&&typeof value==='object'?Object.values(value).some(hasImage):false;
            const previewAngle=hasImage(vehicleData?.Img032)&&hasImage(spec?.Img0100)?32:
              hasImage(vehicleData?.Img001)&&hasImage(spec?.Img0300)?1:
              hasImage(vehicleData?.Img014)&&hasImage(spec?.Img0200)?14:null;
            if(previewAngle!==null&&item.row.styleNumber&&!/-CAN\b/i.test(String(item.row.image||''))){
              const visualizer=route('pages/visualizer');
              visualizer.searchParams.set('vehicle_id',String(selected.id));
              visualizer.searchParams.set('wheel_pn',item.row.sku);
              visualizer.searchParams.set('view_angle',String(previewAngle));
              const button=element('a','View on vehicle',actions);
              button.href=visualizer.href;button.className='mhs-view-on-vehicle';
              button.setAttribute('aria-label','View '+item.row.title+' '+item.row.size+' on your vehicle');
            }
            const reasons=item.fit.reasons.filter(reason=>reason!=='Based on the selected wheel configuration and vehicle fitment data.');
            if(reasons.length){const notes=element('ul','',config);reasons.forEach(reason=>element('li',reason,notes));}
          }
        }
        shown+=8;
        if(shown<filtered.length){const more=element('button','Show more wheel options',listBox);more.type='button';more.addEventListener('click',()=>{more.remove();renderMore();});}
      };
      const paintFiltered=()=>{
        filtered=options.map(items=>items.filter(({row})=>(!fitmentFilters.size||row.size===fitmentFilters.size)&&(!fitmentFilters.finish||row.finish===fitmentFilters.finish))).filter(items=>items.length);
        listBox.replaceChildren();shown=0;
        progress.textContent=filtered.length?filtered.length+' wheel / finish options. Choose a configuration to view it.':'No options match these filters. Try another size or finish.';
        if(!filtered.length){
          for(const [name,control] of [['size',sizes],['finish',finishes]]){
            if(!fitmentFilters[name])continue;
            const remove=element('button',(name==='size'?labels.remove_size:labels.remove_finish),listBox);remove.type='button';
            remove.addEventListener('click',()=>{control.value='';fitmentFilters[name]='';paintFiltered();saveState();});
          }
          element('p',labels.vehicle_kept,listBox).className='mhs-note';
        }
        renderMore();
      };
      paintFiltered();
    }catch{
      if(current())window.MayhemJourney?.track('fitment_unavailable',{surface:'support',state:'error'});
      if(current())progress.textContent='Wheel options could not be checked right now. Try again or email our team.';
      if(current()){const retry=element('button','Try again',optionsBox);retry.type='button';retry.addEventListener('click',discoverFitment);link(labels.ask_team,route('pages/contact'),optionsBox);}
    }
  };

  const lookupAnswer = async (forceFitment = false) => {
    const token = ++generation, question = input.value.trim();
    if (!question) return;
    result.replaceChildren();
    if (/\b(warrant(?:y|ies)|coverage)\b/i.test(question)) {
      status.textContent = labels.warranty_title;
      element('p', labels.warranty_note);
      link(labels.warranty_link, route('pages/warranty'));
      result.focus();
      return;
    }
    try { await load(); } catch { return; }
    if (token !== generation) return;
    const intent = engine.intent(question);
    if(forceFitment)intent.fitment=true;
    const identified = engine.identify(question, rows);
    let candidates = variant.value ? rows.filter(row => String(row.variantId) === variant.value) : rows.filter(row => String(row.productId) === wheel.value);
    if (identified.length) {
      candidates = identified;
      const productIds = [...new Set(identified.map(row => String(row.productId)))];
      if (productIds.length === 1 && wheel.value !== productIds[0]) { wheel.value = productIds[0]; variants(); }
      if (identified.length === 1) variant.value = String(identified[0].variantId);
      else if (variant.value && identified.some(row => String(row.variantId) === variant.value)) candidates = identified.filter(row => String(row.variantId) === variant.value);
      else variant.value = '';
      refreshSummary();
    }
    if (!candidates.length) { status.textContent = labels.choose; q('[data-mhs-setup]').open=true; wheel.focus(); return; }
    const selected = vehicle();
    if (intent.fitment && !selected) { status.textContent = labels.vehicle_needed; q('[data-mhs-pick-vehicle]').focus(); return; }
    const mentionedYear = question.match(/\b(?:19|20)\d{2}\b/)?.[0];
    if (intent.fitment && mentionedYear && (String(selected.year) !== mentionedYear || !engine.compact(question).includes(engine.compact(selected.model)))) {
      status.textContent = labels.vehicle_mismatch; q('[data-mhs-pick-vehicle]').focus(); return;
    }
    if (intent.fitment && candidates.length > 8) { status.textContent = labels.too_many; q('[data-mhs-setup]').open=true; variant.focus(); return; }
    const selectedFields = intent.fields.length ? intent.fields : intent.all ? engine.fields.slice(0, 8) : [];
    if (!intent.fitment && !selectedFields.length) { status.textContent = labels.unknown; return; }
    status.textContent = intent.fitment ? labels.checking : labels.partial;
    if (selectedFields.length) {
      element('p', labels.source_catalog);
      engine.facts(candidates, selectedFields).forEach(fact => {
        const group = element('details', ''); group.open = selectedFields.length <= 3;
        element('summary', fact.label, group);
        const values = [...new Set(fact.entries.map(item => item.value))];
        if (values.length === 1) element('p', values[0] === null ? labels.missing : values[0], group);
        else {
          const list = element('ul', '', group);
          fact.entries.forEach(item => element('li', item.sku + ': ' + (item.value === null ? labels.missing : item.value), list));
        }
      });
    }
    if (intent.fitment) {
      try {
        const service = window.MayhemFitmentService;
        const nativeFits=selected.native?await Promise.all(candidates.map(row=>window.TWGFitmentPreview.evaluateSku(row.sku))):null;
        const [vehicleData, wheels] = selected.native?[null,new Map()]:await Promise.all([service.vehicle(selected.id), service.wheels(candidates.map(row => row.sku)).catch(() => new Map())]);
        if (token !== generation || String(vehicle()?.id) !== String(selected.id)) return;
        element('p', labels.source_fitment);
        candidates.forEach((row,index) => {
          const fit = nativeFits?nativeFits[index]:service.evaluate(vehicleData, window.MayhemManufacturerFitment.wheel(row,wheels.get(String(row.sku).toUpperCase())));
          const article = card(row);
          element('strong', fit.label||fitLabel(fit.state), article);
          const guidance=window.MayhemFitmentUI?.guidance?.(fit.state);
          if(guidance)element('p',guidance,article).className='mhs-note';
          const list = element('ul', '', article);
          fit.reasons.forEach(reason => element('li', reason, list));
          fitmentRecovery(fit,row,article);
          if(fit.state==='unknown')window.MayhemJourney?.track('fitment_unavailable',{surface:'support',state:'unknown'});
        });
        status.textContent = labels.partial;
      } catch { if (token === generation) status.textContent = labels.fit_error; }
    } else {
      [...new Map(candidates.map(row => [String(row.productId), row])).values()].slice(0, 6).forEach(card);
    }
    if (token === generation && result.childElementCount) result.focus();
  };

  const chooseWheel=row=>{
    ++generation;
    cancelAnswer();lastReplySkus=[row.sku];contextStart=history.length;scopeSkus=[row.sku];scopeFitment=false;
    appendTurn('assistant',labels.selected_context+row.title+' · '+row.sku);
    wheel.value=String(row.productId);variants();variant.value=String(row.variantId);
    refreshSummary();q('[data-mhs-setup]').open=false;result.replaceChildren();
    status.textContent='Selected '+row.sku+'. Type your question below.';
    drawFollowups();saveState();input.focus();input.scrollIntoView({block:'center',behavior:'auto'});
    prepareVerification().catch(()=>{});
  };
  const showRecovery=message=>{
    window.MayhemJourney?.track('support_failure',{surface:'support',state:'unavailable'});
    status.textContent=message;q('[data-mhs-recovery]').hidden=false;saveState();
  };
  const drawFollowups=()=>{
    const box=q('[data-mhs-followups]');box.replaceChildren();
    if(input.value.trim())return;
    const chosen=rows.find(row=>String(row.variantId)===variant.value)||rows.find(row=>String(row.productId)===wheel.value);
    const options=chosen?[
      ['Available sizes','What sizes does the '+chosen.title+' come in?'],
      ['Other finishes','What other finishes does the '+(chosen.wheelName||chosen.styleNumber||chosen.title)+' come in?'],
      ['Check my fitment',variant.value?'Will part '+chosen.sku+' fit my selected vehicle?':'Help me choose a configuration for my selected vehicle.']
    ]:[['Find wheel options','Help me find wheel options.'],['Choose a size','How do I choose the right wheel size?']];
    for(const [label,question] of options){const button=element('button',label,box);button.type='button';button.addEventListener('click',()=>{input.value=question;box.replaceChildren();saveState();input.focus();});}
  };
  let history=[],pendingQuestion='',chatBusy=false,activeRequest=null,widgetId=null,widgetToken='',widgetLoading,verificationError=false;
  // Short-lived backend-signed chat grants are kept in memory only, not persisted.
  let chatSession='',chatSessionExpiresAt=0,chatSessionScope='';
  const submit=q('[data-mhs-question-form] button[type="submit"]');
  const widgetBox=q('[data-mhs-verification]');
  const conversation=q('[data-mhs-conversation]');
  const cancelButton=q('[data-mhs-cancel-answer]');
  const setChatBusy=value=>{
    chatBusy=value;submit.disabled=value;input.readOnly=value;
    cancelButton.hidden=!value;
    if(!value){pendingQuestion='';drawConversation();}
    conversation.setAttribute('aria-busy',String(value));
  };
  const cancelAnswer=()=>{
    ++generation;
    activeRequest?.abort();activeRequest=null;
    pendingQuestion='';localBusy=false;
    setChatBusy(false);status.textContent='';
  };
  cancelButton.addEventListener('click',()=>{cancelAnswer();resetVerification();status.textContent=labels.answer_cancelled;saveState();input.focus();});
  dialog.addEventListener('close',()=>{cancelAnswer();saveState();});
  const contextKey=()=>JSON.stringify([vehicle()?.id||'',wheel.value,variant.value]);
  const drawConversation=()=>{
    conversation.replaceChildren();
    if(!history.length){
      const greeting=element('article','',conversation);greeting.className='mhs-chat-message assistant';
      element('strong','Mayhem AI',greeting);element('p',labels.welcome,greeting);
    }
    history.forEach(item=>{
      const article=document.createElement('article');
      article.className='mhs-chat-message '+item.role;
      const title=document.createElement('strong');title.textContent=item.role==='user'?'You':'Mayhem AI';
      const text=document.createElement('p');
      if(item.role==='assistant'){
        // Render only bold spans; all model output stays inert text.
        item.content.split(/(\*\*[^*\n]+\*\*)/g).forEach(part=>{
          if(part.startsWith('**')&&part.endsWith('**')&&part.length>4){
            const strong=document.createElement('strong');strong.textContent=part.slice(2,-2);text.append(strong);
          }else{text.append(document.createTextNode(part));}
        });
      }else{text.textContent=item.content;}
      article.append(title,text);
      if(item.vehicleLabel)element('small',item.vehicleLabel,article);
      if(item.role==='assistant'&&Array.isArray(item.productSkus)){
        const matched=item.productSkus.slice(0,12).map(sku=>rows.find(row=>String(row.sku).toUpperCase()===String(sku).toUpperCase())).filter(Boolean);
        if(matched.length){
          const cards=element('div','',article);cards.className='mhs-chat-products';
          element('small',labels.configurations_label,cards);
          if(!vehicle())element('small',labels.fitment_note,cards);
          let overflow;
          for(const [index,row] of matched.entries()){
            if(index===3){overflow=element('details','',cards);element('summary',labels.more_wheels,overflow);}
            const card=element('div','',overflow||cards);card.className='mhs-chat-product';
            if(row.image){const source=new URL(row.image,location.origin);if(source.protocol==='https:'){const img=document.createElement('img');img.src=source.href;img.alt='';img.width=56;img.height=56;img.loading='lazy';card.append(img);}}
            const body=element('div','',card);element('strong',row.title,body);
            element('small',[row.size,row.boltOption,row.offset==null?'':row.offset+' mm',row.sku].filter(Boolean).join(' · '),body);
            const url=new URL(row.url,location.origin);if(url.origin!==location.origin)continue;
            url.searchParams.set('variant',row.variantId);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
            const details=element('a','View wheel details →',body);details.href=url.href;
            const ask=element('button','Ask about this wheel',body);ask.type='button';ask.addEventListener('click',()=>chooseWheel(row));
          }
        }
      }
      conversation.append(article);
    });
    if(pendingQuestion){
      const pendingUser=element('article','',conversation);pendingUser.className='mhs-chat-message user mhs-pending';
      element('strong','You',pendingUser);element('p',pendingQuestion,pendingUser);
    }
    input.placeholder=history.length?'Ask a follow-up…':labels.example;
  };

  const sessionKey='mayhem:support-conversation:v2';
  let stateReady=false;
  const saveState=()=>{
    if(!stateReady)return;
    try{sessionStorage.setItem(sessionKey,JSON.stringify({savedAt:Date.now(),vehicleId:String(vehicle()?.id||''),productId:wheel.value,variantId:variant.value,history,scopeSkus,scopeFitment,contextStart,draft:input.value.slice(0,600),filters:fitmentFilters}));}catch{}
  };
  const restoreState=()=>{
    if(stateReady)return;stateReady=true;
    try{
      const raw=sessionStorage.getItem(sessionKey);if(!raw||raw.length>60000)return;
      const saved=JSON.parse(raw);
      if(!Number.isFinite(saved.savedAt)||Date.now()-saved.savedAt>1800000||saved.savedAt>Date.now()||saved.vehicleId!==String(vehicle()?.id||''))return;
      const chosen=rows.find(row=>String(row.variantId)===saved.variantId&&String(row.productId)===saved.productId);
      if(saved.variantId&&!chosen)return;
      if(saved.productId&&!rows.some(row=>String(row.productId)===saved.productId))return;
      wheel.value=saved.productId||'';variants();variant.value=chosen?String(chosen.variantId):'';
      history=Array.isArray(saved.history)?saved.history.filter(m=>['user','assistant'].includes(m?.role)&&typeof m.content==='string'&&m.content.length<=3000).slice(-40):[];
      while(JSON.stringify(history).length>40000)history.splice(0,2);
      scopeSkus=Array.isArray(saved.scopeSkus)?saved.scopeSkus.filter(sku=>rows.some(row=>row.sku===sku)):[];
      scopeFitment=saved.scopeFitment===true;contextStart=Math.min(history.length,Math.max(0,Number(saved.contextStart)||0));
      input.value=typeof saved.draft==='string'?saved.draft.slice(0,600):'';
      fitmentFilters={size:typeof saved.filters?.size==='string'?saved.filters.size:'',finish:typeof saved.filters?.finish==='string'?saved.filters.finish:''};
      drawConversation();drawFollowups();
    }catch{}
  };
  window.addEventListener('mayhem:ask-product-fitment', async event => {
    const context = event.detail || {};
    q('.mhs-launcher').click();
    q('[data-mhs-answer="product"]').click();
    const token = ++generation;
    input.value = 'Can you verify whether ' + String(context.title || 'this wheel') + ' fits my selected vehicle?';
    try {
      await load();
      if (token !== generation) return;
      const matchedProduct = context.sku && rows.find(row => String(row.sku).toUpperCase() === String(context.sku).toUpperCase());
      wheel.value = String(context.productId || matchedProduct?.productId || '');
      variants();
      const exact=rows.find(row=>String(row.productId)===wheel.value && ((context.variantId && String(row.variantId)===String(context.variantId)) || (context.sku && String(row.sku).toUpperCase()===String(context.sku).toUpperCase())));
      variant.value=exact?String(exact.variantId):'';
      input.value = typeof context.question==='string' ? context.question.slice(0,600) : 'Can you verify whether ' + String(exact?.sku || context.title || 'this wheel') + ' fits my selected vehicle?';
      resetConversation(); refreshVehicle(); saveState(); input.focus();
    } catch { input.focus(); }
  });
  input.addEventListener('input',()=>{saveState();drawFollowups();});
  window.addEventListener('pagehide',saveState);

  const resetConversation=()=>{cancelAnswer();history=[];scopeSkus=[];scopeFitment=false;awaitingVehicleQuestion='';contextStart=0;chatSession='';chatSessionExpiresAt=0;chatSessionScope='';drawConversation();};
  const resetVerification=()=>{widgetToken='';verificationError=false;if(widgetId!==null&&window.turnstile)window.turnstile.reset(widgetId);};
  const prepareVerification=()=>{
    if(widgetLoading)return widgetLoading;
    widgetLoading=new Promise((resolve,reject)=>{
      const render=()=>{
        try {
          widgetId=window.turnstile.render(widgetBox,{sitekey:root.dataset.turnstileSitekey,action:'mayhem_support',theme:'light',appearance:'interaction-only',size:'flexible',
            callback:token=>{widgetToken=token;verificationError=false;widgetBox.classList.remove('needs-interaction');if(!chatBusy)status.textContent='';},
            'before-interactive-callback':()=>{widgetBox.classList.add('needs-interaction');if(chatBusy)status.textContent='Please complete the quick check below. Your question will send automatically.';},
            'after-interactive-callback':()=>{widgetBox.classList.remove('needs-interaction');},
            'timeout-callback':()=>{widgetToken='';verificationError=true;},
            'expired-callback':()=>{widgetToken='';},
            'error-callback':()=>{widgetToken='';verificationError=true;return true;}
          });resolve();
        }catch(e){widgetLoading=null;reject(e);}
      };
      if(window.turnstile){window.turnstile.ready(render);return;}
      window.mayhemSupportTurnstileReady=render;
      const script=document.createElement('script');
      script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?onload=mayhemSupportTurnstileReady&render=explicit';
      script.async=true;script.defer=true;script.onerror=()=>{widgetLoading=null;reject(new Error('Verification unavailable'));};
      document.head.append(script);
    });return widgetLoading;
  };

  let lastReplySkus=[],scopeSkus=[],scopeFitment=false,awaitingVehicleQuestion='',contextStart=0,localBusy=false;
  const appendTurn=(role,content,extra={})=>{
    history.push({role,content:String(content).slice(0,3000),...extra});
    if(history.length>40){const removed=history.length-40;history.splice(0,removed);contextStart=Math.max(0,contextStart-removed);}
    drawConversation();saveState();
    conversation.lastElementChild?.scrollIntoView({block:'nearest'});
  };
  const changeContext=message=>{
    cancelAnswer();contextStart=history.length;
    appendTurn('assistant',message);
  };
  const requestPerson=question=>{
    appendTurn('user',question);input.value='';
    appendTurn('assistant',labels.handoff_intro);
    q('.mhs-chat-toolbar a[href]').click();
  };
  const conversationalReply=async(question,resume=false)=>{
    const human=/\b(?:talk|speak|connect)\s+(?:me\s+)?(?:to|with)\s+(?:(?:a|the|your)\s+)?(?:person|someone|human|agent|representative|team|support)\b|\bcontact (?:support|customer service)\b|^(?:human|customer service|live agent)[.!?\s]*$/i.test(question);
    if(human){requestPerson(question);return true;}
    const intent=engine.intent(question);
    const installationQuestion=/\b(?:install(?:ation|ing)?|hub[ -]?rings?|spacers?|modifications?)\b|\b(?:need|needs|require|requires|required)\b.*\b(?:hardware|lift|level|rings?)\b/i.test(question);
    const size=question.match(/\b(\d{2})\s*(?:[- ]?inch(?:es)?|["”])|\b(\d{2})\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    const shortSize=scopeSkus.length&&question.match(/^(?:what about |how about |only |show (?:me )?(?:the )?)?(\d{2})(?:s)?[.!?\s]*$/i);
    const finishWords=question.match(/\b(bronze|black|chrome|silver|milled|machined|polished|red|blue|grey|gray)\b/ig)||[];
    let explicit=engine.identify(question,rows);
    // A named style must not override the exact configuration for a spec question.
    // Keep explicit part-number requests and size/finish exploration independent.
    const selectedRow=rows.find(row=>String(row.variantId)===variant.value);
    const exactPart=rows.some(row=>row.sku && (' '+String(question).toLowerCase().replace(/[^a-z0-9]+/g,' ').trim()+' ').includes(' '+String(row.sku).toLowerCase().replace(/[^a-z0-9]+/g,' ').trim()+' '));
    const broadOptions=/\b(?:all|other|different|available)\s+(?:sizes?|configurations?|finishes?|offsets?|bores?)\b|\b(?:what|which)\s+sizes?\b|\bcompare\b/i.test(question);
    const exactSpec=intent.fields.some(([key])=>!['size','finish'].includes(key))||intent.all;
    const selectedReference=/\b(?:selected|current|this)\s+(?:(?:wheel|rim|part|configuration)|[a-z]+\s+wheel)\b/i.test(question);
    if(selectedRow && exactSpec && !exactPart && !broadOptions && !size && !shortSize && !finishWords.length &&
      (selectedReference || (explicit.length && explicit.some(row=>String(row.variantId)===variant.value)))) explicit=[selectedRow];
    const followup=scopeSkus.length&&(size||shortSize||finishWords.length||intent.fields.length||intent.fitment||installationQuestion||/\b(these|those|they|it|other finishes|all sizes)\b/i.test(question));
    const browse=/\b(?:what|which|find|show|looking for)\b.*\b(?:wheels?|fits?|options)\b/i.test(question)&&!explicit.length&&!scopeSkus.length&&!wheel.value;
    if(!resume&&!explicit.length&&!followup&&!browse&&!intent.fitment&&!installationQuestion&&!(wheel.value&&(intent.fields.length||intent.all)))return false;
    if(!rows.length){await load();return conversationalReply(question,resume);}
    if(!resume)appendTurn('user',question);
    input.value='';drawFollowups();status.textContent=labels.checking;
    let candidates=explicit.length?explicit:scopeSkus.length?rows.filter(row=>scopeSkus.includes(row.sku)):variant.value?rows.filter(row=>String(row.variantId)===variant.value):rows.filter(row=>String(row.productId)===wheel.value);
    if(explicit.length){scopeSkus=explicit.map(row=>row.sku);scopeFitment=false;}
    if(!explicit.length&&!size&&!shortSize&&!finishWords.length&&lastReplySkus.length&&/\b(these|those|they|it)\b/i.test(question))candidates=rows.filter(row=>lastReplySkus.includes(row.sku));
    const wantsFitment=installationQuestion||intent.fitment||browse||(scopeFitment&&Boolean(followup));
    const mentionedYear=question.match(/\b(?:19|20)\d{2}\b/)?.[0];
    if(wantsFitment&&vehicle()&&mentionedYear&&String(vehicle().year)!==mentionedYear){
      awaitingVehicleQuestion=question;status.textContent='';appendTurn('assistant',labels.vehicle_mismatch);openVehiclePicker();return true;
    }
    if(wantsFitment&&!vehicle()){
      awaitingVehicleQuestion=question;scopeFitment=true;
      if(candidates.length)scopeSkus=candidates.map(row=>row.sku);
      status.textContent='';appendTurn('assistant',labels.vehicle_prompt);
      openVehiclePicker();return true;
    }
    if(browse&&!candidates.length)candidates=rows;
    if(!candidates.length){status.textContent='';appendTurn('assistant',labels.wheel_prompt);return true;}
    if(!scopeSkus.length)scopeSkus=candidates.map(row=>row.sku);
    // A size follow-up concerns the wheel style, not just the selected SKU.
    // Resolve the single style from verified catalog rows before expanding it.
    const sizeListQuestion=/\b(?:what|which|all|other|different|available)\s+(?:wheel\s+)?sizes?\b|\bsizes?\s+(?:does|do|are|available|offered|come)\b/i.test(question);
    if(!explicit.length&&(sizeListQuestion||shortSize||size)){
      const styles=new Set(candidates.map(row=>row.styleNumber).filter(Boolean));
      if(styles.size>1){status.textContent='';appendTurn('assistant','Which wheel style would you like the sizes for?');return true;}
      if(styles.size===1)candidates=rows.filter(row=>styles.has(row.styleNumber));
    }
    // A finish follow-up changes the finish of the SAME wheel style, not the
    // existing exact SKU. Re-expand that style before filtering by color.
    if(finishWords.length&&!explicit.length){
      const styles=new Set(candidates.map(row=>row.styleNumber).filter(Boolean));
      if(styles.size>1){status.textContent='';appendTurn('assistant','Which wheel style do you mean?');return true;}
      if(styles.size===1)candidates=rows.filter(row=>styles.has(row.styleNumber));
    }
    if(/\bother (?:finishes|colors|colours)\b/i.test(question)){
      const styles=new Set(candidates.map(row=>row.styleNumber));
      candidates=rows.filter(row=>styles.has(row.styleNumber));
      scopeSkus=candidates.map(row=>row.sku);
    }
    const diameter=size?.[1]||size?.[2]||shortSize?.[1];
    if(diameter)candidates=candidates.filter(row=>Number(String(row.size).split(/[x×]/i)[0])===Number(diameter)&&(!size?.[3]||Number(String(row.size).split(/[x×]/i)[1])===Number(size[3])));
    if(finishWords.length)candidates=candidates.filter(row=>finishWords.every(word=>String(row.finish).toLowerCase().includes(word.toLowerCase())));
    if(!candidates.length){status.textContent='';appendTurn('assistant',labels.no_filtered);return true;}
    const ticket=++generation,identity=contextKey();
    localBusy=true;setChatBusy(true);
    try{
      let fits=[];
      if(wantsFitment){
        fits=await Promise.all(candidates.map(row=>window.TWGFitmentPreview.evaluateSku(row.sku)));
        if(ticket!==generation||identity!==contextKey())return true;
        scopeFitment=true;
        const matched=candidates.filter((row,index)=>['fits','caution'].includes(fits[index]?.state));
        if(matched.length&&!diameter&&!finishWords.length)scopeSkus=matched.map(row=>row.sku);
      }
      const shown=wantsFitment?candidates.filter((row,index)=>['fits','caution'].includes(fits[index]?.state)):candidates;
      const selectedFields=intent.fields.length?intent.fields:engine.fields.slice(0,4);
      let lines=[];
      if(installationQuestion){
        lines=['Installation requirements for '+vehicleDescription(vehicle())+':'];
        candidates.slice(0,6).forEach((row,index)=>{
          const fit=fits[index]||{};
          const notes=[...new Set([
            ...(fit.accessoryNotes||[]),
            ...(fit.applications||[]).flatMap(app=>app.sourceNotes||[])
          ].filter(note=>typeof note==='string'&&note.trim()))];
          if(fit.rawApplication?.accessories?.hub_ring_needed===true&&!notes.some(note=>/hub[ -]?rings?/i.test(note)))notes.push('Hub rings required.');
          lines.push(row.sku+' · '+row.size+' · '+(fit.label||fitLabel(fit.state||'unknown')));
          if(notes.length)lines.push('Application notes: '+notes.join(' '));
          else lines.push('The fitment data does not include installation notes for this configuration. That does not confirm that no additional hardware or modifications are needed.');
        });
        if(candidates.length>6)lines.push('Choose an exact part number to check its installation notes.');
      }else if(wantsFitment){
        lines=[labels.fitment_heading];
        const report=shown.length?shown.slice(0,6):candidates.slice(0,3);
        report.forEach(row=>{
          const fit=fits[candidates.indexOf(row)];
          lines.push(row.sku+' · '+row.size+' · '+(fit.label||fitLabel(fit.state)));
          (fit.reasons||[]).forEach(note=>lines.push(String(note)));
        });
        if(!shown.length)lines.push(labels.no_options);
      }else if(sizeListQuestion&&!diameter&&!finishWords.length){
        const sizes=[...new Set(shown.map(row=>row.size).filter(Boolean))]
          .sort((a,b)=>Number.parseFloat(a)-Number.parseFloat(b)||String(a).localeCompare(String(b)));
        const style=[...new Set(shown.map(row=>row.styleNumber).filter(Boolean))][0];
        lines=[sizes.length
          ? 'Style '+style+' is listed in '+sizes.join(', ')+'. Available finishes and bolt patterns vary by configuration.'
          : 'I couldn’t confirm the sizes for that wheel.'];
      }else if(finishWords.length){
        const finishes=[...new Set(candidates.map(row=>row.finish).filter(Boolean))];
        lines=[finishes.length
          ? 'Yes, I found these finishes for the wheels we were discussing: '+finishes.join(', ')+'.'
          : 'I couldn’t verify that finish for these wheels.'];
      }else{
        const facts=engine.facts(candidates,selectedFields).map(fact=>({
          label:fact.label,
          values:[...new Set(fact.entries.map(entry=>entry.value).filter(value=>value!==null))]
        }));
        if(facts.length===1){
          const fact=facts[0];
          const label=/^sizes?$/i.test(fact.label)?'sizes':/^finishes?$/i.test(fact.label)?'finishes':fact.label.toLowerCase();
          lines=[fact.values.length
            ? 'The listed '+label+(fact.values.length===1?' is ':' are ')+fact.values.join(', ')+'.'
            : 'I couldn’t confirm the '+label+' for that wheel.'];
        }else{
          lines=['Here’s what I found: '+facts.map(fact=>fact.label+': '+(fact.values.length?fact.values.join(', '):labels.missing)).join('; ')+'.'];
        }
      }
      if(ticket!==generation||identity!==contextKey())return true;
      lastReplySkus=shown.map(row=>row.sku);
      if(finishWords.length&&shown.length)scopeSkus=shown.map(row=>row.sku);
      const showCards=(!installationQuestion&&wantsFitment)||browse||/\b(?:show|find|options|choices|compare)\b/i.test(question);
      appendTurn('assistant',lines.join('\n\n'),{productSkus:showCards?shown.slice(0,3).map(row=>row.sku):[],grounded:true,vehicleLabel:wantsFitment?vehicleDescription(vehicle()):''});
      result.replaceChildren();optionsBox.replaceChildren();status.textContent='';drawFollowups();saveState();
    }catch{
      if(ticket===generation){appendTurn('assistant',labels.local_error);input.value=question;showRecovery(labels.local_error);}
    }finally{
      if(ticket===generation){localBusy=false;setChatBusy(false);input.focus({preventScroll:true});}
    }
    return true;
  };

  const answer=async()=>{
    if(chatBusy||localBusy)return;
    const chatQuestion=input.value.trim();if(!chatQuestion)return;
    localBusy=true;setChatBusy(true);
    try{await load();}catch{showRecovery(labels.local_error);return;}finally{localBusy=false;setChatBusy(false);}
    if(await conversationalReply(chatQuestion))return;
    if(chatBusy)return;
    if(/^(?:(?:what|which) (?:wheels? )?(?:will )?fits? (?:my|this|the) (?:truck|vehicle)|show (?:me )?(?:all )?(?:matching wheels|wheel options))\??$/i.test(input.value.trim())){
      browseFitment=true;discoverFitment();return;
    }
    const appChat=window.TWGFitmentPreview?.status()?.mode==='twg_app_draft';
    if(!appChat&&window.MayhemSupportAnswers.intent(input.value.trim()).fitment)return lookupAnswer();
    if(!root.dataset.chatEndpoint){showRecovery(labels.local_error);return;}
    if(chatBusy)return;
    const question=input.value.trim();if(!question)return;
    if(/\b(?:talk to|speak to|contact|connect me (?:to|with))\s+(?:(?:a|the|your)\s+)?(?:human|person|representative|support|team|customer service)\b|\b(?:email (?:your|the) (?:team|support)|customer service|live agent)\b|^(?:human|representative|email|contact support)[.!?\s]*$/i.test(question)){
      result.replaceChildren();element('p',labels.handoff_intro);
      link('Email our team',route('pages/contact'));result.focus();return;
    }
    const token=++generation,selection=contextKey(),selected=vehicle();
    pendingQuestion=question;drawConversation();
    setChatBusy(true);saveState();
    q('[data-mhs-recovery]').hidden=true;status.textContent=widgetBox.classList.contains('needs-interaction')?'Please complete the quick check below. Your question will send automatically.':'Preparing your answer…';
    const requestContext={fitmentProvider:appChat?'twg_app':'legacy',
      appVehicle:appChat?window.TWGFitmentPreview?.selectedVehicle()?.query:null,
      vehicle:selected&&!selected.native?{id:selected.id}:null,
      productId:wheel.value||null,variantId:variant.value||null,
      focusSkus:scopeSkus.filter(sku=>rows.some(row=>row.sku===sku)).slice(0,6)};
    // Mirror the backend grant's selection fields. A different wheel or vehicle
    // needs a fresh real Turnstile token before a new signed grant can be issued.
    const requestScope=JSON.stringify([requestContext.fitmentProvider,requestContext.appVehicle,
      requestContext.vehicle,requestContext.productId,requestContext.variantId,requestContext.focusSkus]);
    const useSession=!!chatSession&&Date.now()+5000<chatSessionExpiresAt&&chatSessionScope===requestScope;
    if(!useSession){chatSession='';chatSessionExpiresAt=0;chatSessionScope='';}
    let verificationTimer;
    try {
      if(!useSession){
        if(verificationError||(widgetId!==null&&!widgetToken))resetVerification();
        await Promise.race([prepareVerification(),new Promise((_,reject)=>{verificationTimer=setTimeout(()=>reject(new Error('Verification unavailable')),20000);})]);
        const deadline=Date.now()+90000,backgroundDeadline=Date.now()+20000;
        while(!widgetToken&&!verificationError&&Date.now()<deadline){
          if(token!==generation||selection!==contextKey()||input.value.trim()!==question||panel.hidden)break;
          if(Date.now()>backgroundDeadline&&!widgetBox.classList.contains('needs-interaction'))break;
          await new Promise(resolve=>setTimeout(resolve,100));
        }
        if(token!==generation||selection!==contextKey()||input.value.trim()!==question||panel.hidden){if(token===generation)setChatBusy(false);return;}
        if(!widgetToken)throw new Error('Verification unavailable');
      }
    }catch{
      if(token===generation)setChatBusy(false);
      if(token===generation)showRecovery('We couldn’t connect right now. Your question is saved—try again or email our team.');
      return;
    }finally{clearTimeout(verificationTimer);}
    const sentToken=useSession?'':widgetToken;
    if(!useSession)widgetToken='';
    status.textContent='Checking your question…';q('[data-mhs-recovery]').hidden=true;conversation.setAttribute('aria-busy','true');result.replaceChildren();
    const controller=new AbortController();activeRequest=controller;const timer=setTimeout(()=>controller.abort(),60000);
    try {
      const response=await fetch(root.dataset.chatEndpoint,{method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},signal:controller.signal,
        body:JSON.stringify({message:question,history:history.slice(contextStart).slice(-10).map(({role,content})=>({role,content})),...(useSession?{chatSession}:{turnstileToken:sentToken}),context:requestContext})});
      const data=await response.json();
      if(token!==generation||selection!==contextKey())return;
      if(data.fitmentUnavailable===true){pendingQuestion='';appendTurn('user',question);appendTurn('assistant','I couldn’t confirm that fitment. Please select the exact wheel and vehicle, or contact our team for help.');input.value='';return;}
      if(!response.ok||!data.available||typeof data.text!=='string'){
        if(response.status===403){chatSession='';chatSessionExpiresAt=0;chatSessionScope='';resetVerification();}
        showRecovery(response.status===429?'Please wait a minute, then retry. Your question is kept.':response.status===403?'Please complete the verification, then retry. Your question is kept.':'I couldn’t get an answer right now. Your question is kept—retry or email our team.');
        return;
      }
      if(/^Fitment status:/i.test(data.text)){pendingQuestion='';appendTurn('user',question);appendTurn('assistant','I couldn’t confirm that fitment. Please select the exact wheel and vehicle, or contact our team for help.');input.value='';return;}
      if(typeof data.chatSession==='string'&&data.chatSession.length<=1400&&
        Number.isFinite(data.chatSessionExpiresAt)&&data.chatSessionExpiresAt>Date.now()+5000){
        chatSession=data.chatSession;chatSessionExpiresAt=data.chatSessionExpiresAt;chatSessionScope=requestScope;
      }else{chatSession='';chatSessionExpiresAt=0;chatSessionScope='';}
      pendingQuestion='';history.push({role:'user',content:question},{role:'assistant',content:data.text.slice(0,3000),productSkus:Array.isArray(data.productSkus)?data.productSkus.filter(sku=>typeof sku==='string'&&sku.length<=100).slice(0,3):[]});
      while(history.length>40||JSON.stringify(history).length>40000){history.splice(0,2);contextStart=Math.max(0,contextStart-2);}
      drawConversation();if(input.value.trim()===question)input.value='';status.textContent='';q('[data-mhs-recovery]').hidden=true;drawFollowups();saveState();
      conversation.lastElementChild?.scrollIntoView({block:'nearest'}); input.focus({preventScroll:true});
    }catch{if(token===generation)showRecovery('I couldn’t connect right now. Your question is kept—retry or email our team.');}
    finally{clearTimeout(timer);if(activeRequest===controller){activeRequest=null;setChatBusy(false);if(!chatSession)resetVerification();}}
  };
  q('[data-mhs-recovery-lookup]').addEventListener('click',()=>{cancelAnswer();q('[data-mhs-recovery]').hidden=true;conversationalReply(input.value.trim());});
  q('[data-mhs-retry]').addEventListener('click',()=>q('[data-mhs-question-form]').requestSubmit());
  q('[data-mhs-clear-wheel]').addEventListener('click',()=>{scopeSkus=[];scopeFitment=false;changeContext(labels.clear_context);wheel.value='';variants();variant.value='';refreshSummary();drawFollowups();saveState();input.focus();});
  q('[data-mhs-setup-done]')?.addEventListener('click',()=>{q('[data-mhs-setup]').open=false;input.focus();});
  q('[data-mhs-use-lookup]')?.addEventListener('click',()=>{if(!input.value.trim()){status.textContent='Type what you want to look up, then choose Search specifications / fitment.';input.focus();return;}conversationalReply(input.value.trim()).then(handled=>{if(!handled){status.textContent=labels.wheel_prompt;q('[data-mhs-setup]').open=true;}});});
  q('[data-mhs-chat-clear]')?.addEventListener('click',()=>{++generation;resetConversation();input.value='';result.replaceChildren();status.textContent='Conversation cleared.';saveState();input.focus();});

  root.addEventListener('click', event => {
    if(event.target.closest('.mhs-launcher')){
      home.hidden=true;panel.hidden=false;q('[data-mhs-contact-panel]').hidden=true;
      drawConversation();refreshVehicle();load().catch(()=>{});input.focus({preventScroll:true});
    }
    const contactLink = event.target.closest('a[href]');
    if(contactLink)saveState();
    if (contactLink && !contactLink.matches('.mhs-launcher,[data-mhs-contact-page]') && new URL(contactLink.href, location.origin).pathname.endsWith('/pages/contact')) {
      event.preventDefault();
      cancelAnswer();
      const selected = vehicle();
      // Carry the *exact matching catalog SKU* from the customer's most
      // recent conversation question even when no wheel dropdown was used.
      // Never infer a different variant from a style name or AI response.
      const userMessages=[...history.slice(contextStart),{role:'user',content:input.value.trim()}]
        .filter(item=>item.role==='user').reverse();
      const mentionedRow=userMessages.map(item=>{
        const words=String(item.content||'').toUpperCase().split(/[^A-Z0-9-]+/);
        return rows.find(row=>row.sku&&scopeSkus.includes(row.sku)&&words.includes(String(row.sku).toUpperCase()));
      }).find(Boolean);
      const conversationRow=mentionedRow||(scopeSkus.length===1?rows.find(item=>item.sku===scopeSkus[0]):null);
      const contactVariant=contactLink.dataset.mhsContactVariant || (conversationRow?String(conversationRow.variantId):variant.value);
      const row = rows.find(item => String(item.variantId) === contactVariant) || rows.find(item => String(item.productId) === wheel.value);
      const context = {
        created: Date.now(),
        question: panel.hidden ? '' : [...history.map(item=>(item.role==='user'?'Customer: ':'Mayhem AI: ')+item.content),input.value.trim()?'Current question: '+input.value.trim():''].filter(Boolean).join('\n\n').slice(-10000),
        vehicle: selected ? vehicleDescription(selected) : '',
        wheel: row ? [row.title, contactVariant ? row.size : '',contactVariant ? row.boltOption : '',contactVariant&&row.offset!=null ? row.offset+' mm' : '',contactVariant ? row.sku : ''].filter(Boolean).join(' · ') : ''
      };
      try { sessionStorage.setItem('mayhem:contact-context:v1', JSON.stringify(context)); } catch {}
      const contactPanel=q('[data-mhs-contact-panel]');
      contactPanel.dataset.returnPanel=panel.hidden?'home':'answer';
      root.dispatchEvent(new CustomEvent('mayhem:contact-mode',{detail:true}));
      home.hidden=true;panel.hidden=true;contactPanel.hidden=false;
      let mount=document.getElementById('MayhemContactMount');
      if(!mount){
        mount=document.createElement('div');mount.id='MayhemContactMount';
        q('[data-mhs-contact-content]').append(mount);
        const sections=[document.querySelector('.mayhem-support-email')?.closest('.shopify-section'),document.querySelector('[data-form-root]')?.closest('.shopify-section')].filter(Boolean);
        const places=sections.map(section=>{const marker=document.createComment('contact form position');section.before(marker);placeContactNode(mount,section);return [section,marker];});
        if(!places.length){
          // Shopify denies contact-page framing. Keep the saved handoff in
          // sessionStorage and provide normal navigation if no inline app block exists.
          const recovery=document.createElement('a');
          recovery.href=route('pages/contact').href;
          recovery.textContent='Open contact form';
          mount.append(recovery);
        }
        const restoreContact=()=>{
          if(dialog.open)return; // switching modal state keeps the form alive
          for(const [section,marker] of places){placeContactNode(marker.parentNode,section,marker);marker.remove();}
          mount.remove();dialog.removeEventListener('close',restoreContact);
        };
        dialog.addEventListener('close',restoreContact);
      }
      placeContactNode(q('[data-mhs-contact-content]'),mount);mount.hidden=false;
      window.dispatchEvent(new CustomEvent('mayhem:contact-context',{detail:context}));
      q('#MayhemContactPanelTitle').focus();
    }
    if(event.target.closest('[data-mhs-contact-back]')){
      const contactPanel=q('[data-mhs-contact-panel]');contactPanel.hidden=true;
      root.dispatchEvent(new CustomEvent('mayhem:contact-mode',{detail:false}));
      const destination=contactPanel.dataset.returnPanel==='answer'?panel:home;destination.hidden=false;
      destination.querySelector('h3').focus();
    }
    const action = event.target.closest('[data-mhs-answer]');
    if (action) {
      event.preventDefault(); home.hidden = true; panel.hidden = false; q('[data-mhs-contact-panel]').hidden=true;
      input.placeholder = action.dataset.mhsAnswer === 'fitment' ? 'Example: Will the Warrior fit my vehicle?' : labels.example;
      refreshVehicle();drawFollowups();
      browseFitment=action.dataset.mhsAnswer==='fitment';++fitmentRequest;optionsBox.replaceChildren();
      panel.querySelector('h3').textContent=browseFitment?'Wheels for your vehicle':'Ask Mayhem';
      q('.mhs-chat-intro').textContent=browseFitment?'Choose a wheel configuration below. Check any fitment conditions before installation.':labels.chat_intro;
      if(browseFitment){discoverFitment();if(!vehicle())q('[data-mhs-pick-vehicle]').click();}
      else{drawConversation();load().catch(()=>{});}
      panel.querySelector('h3').focus();
    }
    if (event.target.closest('[data-mhs-answer-back]')) { cancelAnswer(); panel.hidden = true; home.hidden = false; home.querySelector('h3').focus(); }
    if (event.target.closest('[data-mhs-pick-vehicle]')) openVehiclePicker();
    if (event.target.closest('[data-mhs-vehicle-cancel]')) closeVehiclePicker();
    if (event.target.closest('[data-mhs-vehicle-retry]')) loadVehicleChoices(vehicleStage);
    if (event.target.closest('[data-mhs-clear-vehicle]')) {
      closeVehiclePicker();
      for (const storage of [window.localStorage, window.sessionStorage]) {
        try { storage.removeItem('mayhem:selected-vehicle-id'); storage.removeItem('mayhem:selected-vehicle'); } catch {}
      }
      window.TWGFitmentPreview?.clearVehicle();
      window.dispatchEvent(new CustomEvent('mayhem:vehicle-changed', {detail:{id:null,vehicle:null,source:'support'}}));
    }
  });
  input.addEventListener('keydown',event=>{
    if(event.key==='Enter'&&!event.shiftKey&&!event.isComposing&&event.keyCode!==229){
      event.preventDefault();if(!event.repeat&&!chatBusy)q('[data-mhs-question-form]').requestSubmit();
    }
  });
  q('[data-mhs-question-form]').addEventListener('submit', event => { event.preventDefault(); answer(); });
  wheel.addEventListener('change', () => { variants();scopeSkus=[];scopeFitment=false;changeContext(labels.selected_context+(wheel.selectedOptions[0]?.textContent||''));refreshSummary();result.replaceChildren();saveState(); });
  variant.addEventListener('change', () => {scopeSkus=[];scopeFitment=false;changeContext(labels.selected_context+(variant.selectedOptions[0]?.textContent||''));refreshSummary();result.replaceChildren();saveState();});
  let lastChatVehicle=String(vehicle()?.id||'');
  const vehicleChanged=()=>{
    const current=String(vehicle()?.id||'');if(current===lastChatVehicle)return;lastChatVehicle=current;
    const resume=awaitingVehicleQuestion;awaitingVehicleQuestion='';
    changeContext(vehicle()?labels.vehicle_context+vehicleDescription(vehicle()):labels.vehicle_cleared);
    refreshVehicle();result.replaceChildren();optionsBox.replaceChildren();fitmentFilters={size:'',finish:''};saveState();
    if(resume&&vehicle()&&!panel.hidden)conversationalReply(resume,true);
    else if(browseFitment&&!returning&&!panel.hidden)discoverFitment();
  };
  window.addEventListener('twg:vehicle-changed',()=>{closeVehiclePicker();vehicleChanged();});
  window.addEventListener('mayhem:vehicle-changed', vehicleChanged);
  window.addEventListener('storage', event => { if (!event.key || event.key.startsWith('mayhem:selected-vehicle')) vehicleChanged(); });
})();










